exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ItemOrderControl[data-v-658ec448] {\n  display: grid;\n  grid-template-columns: 20px 50px 20px;\n}\n.ItemOrderControl_Item[data-v-658ec448] {\n    text-align: center;\n}\n.ItemOrderControl_Input[data-v-658ec448] {\n    height: 14px;\n    width: 40px;\n}\n", ""]);

// exports
